module.exports = __webpack_public_path__ + "img/0-02-0a-d30f1c15514090b8ec498245d8765112c33aa747cf06484570d579a4985c1ef9_a457b678.579a54e7.jpg";